import { render, staticRenderFns } from "./MyDocumentsView.vue?vue&type=template&id=74067fc3&scoped=true"
import script from "./MyDocumentsView.vue?vue&type=script&lang=ts"
export * from "./MyDocumentsView.vue?vue&type=script&lang=ts"
import style0 from "./MyDocumentsView.vue?vue&type=style&index=0&id=74067fc3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74067fc3",
  null
  
)

export default component.exports